import React from "react";

interface ErrorIconProps {
  className?: string;
  onClick?: () => void;
}

export const ErrorIcon = ({ className, onClick }: ErrorIconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <circle cx="12" cy="12" r="12" fill="#CF1B1B" />
    <path d="M8 8L16 16M8 16L16 8" stroke="white" strokeWidth="2" />
  </svg>
);

ErrorIcon.defaultProps = {
  className: "",
  onClick: undefined,
};
